import type { Tier } from '@modules/Dashboard/Memberships/modules/Perks/types'

import type { FormValues } from '../../modules/CustomEmojiModal/types'
import type { Emoji } from '../../types'

export const getEmojiAvailableTo = (emoji: Emoji, tiers: Tier[]) => {
  if (emoji.accessType.type === 'FreeAndPaidMembers') {
    return 'Members & free accounts'
  }

  if (emoji.accessType.type === 'FreeMembers') {
    return 'Free accounts only'
  }

  if (emoji.accessType.type === 'PaidMembers') {
    return 'Members only'
  }

  return emoji.accessType.ids.map((tier) => tiers.find((t) => t.id === tier)?.name).join(', ')
}

export const getAccessType = (values: FormValues) => {
  if (values.access === 'Tiers') {
    return {
      type: 'Tiers' satisfies Emoji['accessType']['type'],
      ids: values.tierIds.map((id) => parseInt(id)),
    } satisfies Emoji['accessType']
  }

  return {
    type: values.access satisfies Emoji['accessType']['type'],
  } satisfies Emoji['accessType']
}
